import * as React from "react";
import {cx} from "emotion";

import "./template-tiles.scss";

import {cs}                         from "@Common/react/chain-services";
import {consumeContext}             from "@Common/react/context";
import {keyed}                      from "@Common/react/keyed";
import {UseState}                   from "@Common/react/use-state";
import {CcApis3}                    from "@Common/tools/cc-integration/cc_apis/cc-apis-3";
import {AlertModal}                 from "@Common/ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";
import {ConfirmDialog}              from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {
    faCopy, faGear, faPaintBrush, faSpinner, faBoxArchive, faTrash
}                                   from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}            from "@fortawesome/react-fontawesome";
import {UserCreatedTemplateModal}   from "../../user-created-template-modal/user-created-template-modal";

export const rTemplateTile = ({activeTab, forceUpdate, index, template, templates, viewMode}) => cs(
    keyed(`TemplateTile${index}-${template?.idPrimary}`),
    consumeContext("apis"),
    consumeContext("catSubStyle"),
    consumeContext("company"),
    consumeContext("routerHistory"),
    consumeContext("systemConstants"),
    ["confirmModal", ({}, next) => ConfirmDialog({next})],
    ["alertModal", ({}, next) => AlertModal({next})],
    ["templateModal",({apis, alertModal, catSubStyle, routerHistory}, next) => UserCreatedTemplateModal({
        key: template?.idPrimary,
        onClick: async (updatedTemplate) => {
            const result = await apis.next.userCreated.updateTemplate({updateFields: {
                idPrimary: updatedTemplate.value.idPrimary,
                name: updatedTemplate.value.name,
                idCategory: updatedTemplate.value.idCategory,
                active: updatedTemplate.value.active
            }});
            if (result?.errors || result?.errorMessage) {
                await alertModal.show({message: "An error has occurred."});
                return false;
            } else {
                let reloadCatSubStyle = false;
                if(templates.value?.[index]?.idCategory != updatedTemplate.value?.idCategory
                    || templates.value?.[index]?.active != updatedTemplate.value?.active
                ){
                    reloadCatSubStyle = true;
                }
                let obj = templates.value;
                obj[index] = {...updatedTemplate.value, idPrimary: result.idPrimary};
                templates.onChange(obj)
                if( reloadCatSubStyle ){
                    forceUpdate.onChange(!forceUpdate.value);
                    await catSubStyle?.reload();
                }
                return true;
            }
        },
        onClose: () => routerHistory.replace(`/manage-templates/${activeTab}`),
        next,
    })],
    ["cloning", (_, next) => UseState({next, initValue: false})],
    ({apis, alertModal, catSubStyle, cloning, company, confirmModal, templateModal, routerHistory, systemConstants}) => (
        <div className={cx("template-card-s7z", !template.active && "inactive")} id={`${template.idPrimary}TemplateId`}>
            <article xd-qa-type="template-card" xd-qa-name={template.idPrimary}
                className={cx(viewMode==="medium" ? "medium-template-item" : "large-template-item", !template.active&&"inactive")}
            >
                {template.images?.[4]?.url ? (
                    <img alt={template.name} src={template.images[4].url}/>
                ) : (
                    <div className="image-placeholder"></div>
                )}
                <div className="template-info">
                    <h4 className="template-name">{template.name}</h4>
                </div>

                <div className="ui">
                    {activeTab !== 'archive' ? <>
                        <button aria-label="Customization" xd-qa-type="button" xd-qa-name="Customization" onClick={() => (
                            routerHistory.push('/manage-templates/private/#new-template-upload-modal-' + template.idPrimary + '-update')
                        )}><FontAwesomeIcon icon={faPaintBrush}/></button>
                        <button aria-label="Edit Template Info" xd-qa-type="button" xd-qa-name="Edit Template Info"
                            onClick={() => templateModal.show()}><FontAwesomeIcon icon={faGear}/></button>
                        {cloning.value ? <div className="spinner-footer" xd-qa-type="label" xd-qa-name="Loading">
                                <FontAwesomeIcon icon={faSpinner} className="fa-pulse"/>
                            </div>
                            : <button aria-label="Clone Template" xd-qa-type="button" xd-qa-name="Clone Template" onClick={async () => {
                                if (await confirmModal.show({
                                    message: "Clone Template",
                                    buttons: {
                                        confirmLabel: "Yes",
                                    }
                                })) {
                                    try {
                                        cloning.onChange(true);
                                        const ccApi = CcApis3({host: systemConstants.value.DS_SERVER_URL});
                                        let ccHostResponse = await ccApi.getHost({
                                            templateId: template?.sourceTemplateId,
                                            stateId: template?.idState
                                        });
                                        const ccApis = CcApis3({
                                            host: ccHostResponse.ccHost,
                                            headers: {
                                                "userguid": `company-${company.idCompany}`
                                            }
                                        })
                                        let clonedTemplate = {...template}
                                        delete clonedTemplate['idPrimary'];
                                        let imageAssetIds = {}
                                        if( template.images && Object.keys(template.images).length ) {
                                            let urls = [];
                                            Object.values(template.images).forEach( (image)=>{ if( image?.url ) urls.push(image?.url); } )
                                            let uploadResult = await apis.next.userCreated.uploadImage( {urls, idAssets: null } );
                                            if( !uploadResult["errorMessage"] ) {
                                                imageAssetIds = uploadResult;
                                            }
                                            else
                                            {
                                                await alertModal.show({message: "An error has occurred cloning assets."});
                                                cloning.onChange(false);
                                                return false;
                                            }
                                        }

                                        let sourceIdState = clonedTemplate.idState;
                                        let sourceIdmlPaths = clonedTemplate.idmlPaths ? JSON.parse(clonedTemplate.idmlPaths): null;

                                        clonedTemplate['idState'] = null;
                                        clonedTemplate['name'] = `Copy of ${clonedTemplate['name']}`;
                                        clonedTemplate['image'] = JSON.stringify(imageAssetIds);
                                        clonedTemplate['idmlPaths'] = null;
                                        const result = await apis.next.userCreated.updateTemplate({updateFields: {...clonedTemplate}});
                                        if (result?.errors || result?.errorMessage) {
                                            await alertModal.show({message: "Error cloning template data."});
                                            cloning.onChange(false);
                                            return;
                                        }
                                        clonedTemplate['idPrimary'] = result.idPrimary;

                                        /**
                                         * Template has been created, only update if a state and/or idml needs to be cloned. State/idml require id primary to be set.
                                         * Do not let failures to clone files prevent displaying new template since it has been created.
                                         */
                                        if( sourceIdState || (sourceIdmlPaths && Object.keys(sourceIdmlPaths).length) ) {
                                            if( sourceIdState ) {
                                                try {
                                                    let clonedStateResult = await ccApis.cloneState({
                                                        templateIds: [template.sourceTemplateId],
                                                        orderId: `user-created-clone-${result.idPrimary}`,
                                                        ccStateId: sourceIdState
                                                    });
                                                    clonedTemplate['idState'] = clonedStateResult.ccReference;
                                                }
                                                catch(e) {
                                                    await alertModal.show({message: "Error cloning template files."});
                                                }
                                            }
                                            if(sourceIdmlPaths && Object.keys(sourceIdmlPaths).length) {
                                                try{
                                                    let clonedIdmlResult = await ccApis.cloneUserCreatedIdmls({
                                                        companyId: company.idCompany,
                                                        idmlPaths: sourceIdmlPaths,
                                                        idPrimary: clonedTemplate.idPrimary
                                                    });
                                                    clonedTemplate['idmlPaths'] = JSON.stringify(clonedIdmlResult);
                                                }
                                                catch(e){
                                                    await alertModal.show({message: "Error cloning template files."});
                                                }
                                            }
                                            if(clonedTemplate.idState || clonedTemplate.idmlPaths) {
                                                const result2 = await apis.next.userCreated.updateTemplate({updateFields: {...clonedTemplate}});
                                                if (result2?.errors || result2?.errorMessage) {
                                                    await alertModal.show({message: "Error cloning template files."});
                                                }
                                            }
                                        }
                                        cloning.onChange(false);
                                        let newList = templates.value;
                                        newList[newList.length] = {...clonedTemplate}
                                        templates.onChange(newList);
                                    }
                                    catch(e) {
                                        await alertModal.show({message: "Error cloning template."});
                                        console.log("ERROR", e);
                                        cloning.onChange(false);
                                    }
                                }
                            }}><FontAwesomeIcon icon={faCopy}/></button>
                        }
                        <button aria-label="Archive Template" xd-qa-type="button" xd-qa-name="Archive Template" onClick={async () => {
                            if (await confirmModal.show({
                                message: "Archive Template",
                                buttons: {
                                    confirmLabel: "Archive",
                                }
                            })) {
                                const result = await apis.next.userCreated.updateTemplate({updateFields: {'idPrimary': template.idPrimary, 'deleted': true}});
                                if (result?.errors || result?.errorMessage) {
                                    await alertModal.show({message: "Error archiving template."});
                                    return;
                                }
                                templates.onChange(templates.value.filter((e) => e.idPrimary != template.idPrimary));
                                await catSubStyle?.reload();
                            }
                        }}><FontAwesomeIcon icon={faBoxArchive}/></button>
                    </> : template.deleted ? <>
                        <div></div>
                        <div></div>
                        <button aria-label="Restore Template" xd-qa-type="button" xd-qa-name="Restore Template" onClick={async () => {
                            if (await confirmModal.show({
                                message: "Restore Template",
                                buttons: {
                                    confirmLabel: "Restore",
                                }
                            })) {
                                const result = await apis.next.userCreated.updateTemplate({updateFields: {'idPrimary': template.idPrimary, 'deleted': false}});
                                if (result?.errors || result?.errorMessage) {
                                    await alertModal.show({message: "Error restoring template."});
                                    return;
                                }
                                templates.onChange(templates.value.filter((e) => e.idPrimary != template.idPrimary));
                                await catSubStyle?.reload();
                            }
                        }}><div className={"box-unarchive"}/></button>
                        <button aria-label="Delete Template" xd-qa-type="button" xd-qa-name="Delete Template" onClick={async () => {
                            if (await confirmModal.show({
                                message: "Delete Template",
                                actionContent: "Template cannot be restored. Are you sure you want to proceed?",
                                buttons: {
                                    confirmLabel: "Delete",
                                }
                            })) {
                                if( template.idState ) {
                                    const ccApis = CcApis3({
                                        host: systemConstants.value.DS_SERVER_URL,
                                        headers: {
                                            "userguid": `company-${company.idCompany}`
                                        }
                                    })
                                    await ccApis.deleteState(template.idState)
                                }
                                const result = await apis.next.userCreated.deleteTemplate({'idPrimary': template.idPrimary});
                                if (result?.errors || result?.errorMessage) {
                                    await alertModal.show({message: "Error deleting template."});
                                    return;
                                }
                                templates.onChange(templates.value.filter((e) => e.idPrimary != template.idPrimary));
                            }
                        }}><FontAwesomeIcon icon={faTrash}/></button>
                    </> : <>
                        <div></div>
                        <div></div>
                        <button aria-label="Edit Template Info" xd-qa-type="button" xd-qa-name="Edit Template Info"
                            onClick={() => templateModal.show()}><FontAwesomeIcon icon={faGear}/></button>
                        <button aria-label="Delete Template" xd-qa-type="button" xd-qa-name="Delete Template" onClick={async () => {
                            if (await confirmModal.show({
                                message: "Delete Template",
                                actionContent: "Template cannot be restored. Are you sure you want to proceed?",
                                buttons: {
                                    confirmLabel: "Delete",
                                }
                            })) {
                                if( template.idState ) {
                                    const ccApis = CcApis3({
                                        host: systemConstants.value.DS_SERVER_URL,
                                        headers: {
                                            "userguid": `company-${company.idCompany}`
                                        }
                                    })
                                    await ccApis.deleteState(template.idState)
                                }
                                const result = await apis.next.userCreated.deleteTemplate({'idPrimary': template.idPrimary});
                                if (result?.errors || result?.errorMessage) {
                                    await alertModal.show({message: "Error deleting template."});
                                    return;
                                }
                                templates.onChange(templates.value.filter((e) => e.idPrimary != template.idPrimary));
                            }
                        }}><FontAwesomeIcon icon={faTrash}/></button>
                    </>}
                </div>
            </article>
        </div>
    )
);